// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__22q3X","large":"styles_large__odleq"};